import { VisitGeneratedEntity } from "./generated/VisitGeneratedEntity";
import { startOfToday, endOfToday } from "date-fns";

export abstract class VisitEntity extends VisitGeneratedEntity {
    public get isVisitToday(): boolean {
        if (this.isDeleted()) {
            return false;
        }

        return this.date >= startOfToday() && this.date < endOfToday();
    }

    public get isPast(): boolean {
        return this.date < startOfToday();
    }

    public get displayName(): string {
        const separator = " - ";

        const todayString = this.entityContext.localizationService.l("Today");

        if (this.isVisitToday && this.region && this.object) {
            return todayString + separator + this.region.name + separator + this.object;
        } else if (this.isVisitToday && this.region) {
            return todayString + separator + this.region.name;
        } else if (this.isVisitToday && this.object) {
            return todayString + separator + this.object;
        } else if (this.isVisitToday) {
            return todayString;
        } else if (this.region && this.object) {
            return (
                this.entityContext.internalizationService.formatDate(this.date, "medium") +
                separator +
                this.region.name +
                separator +
                this.object
            );
        } else if (this.object) {
            return this.entityContext.internalizationService.formatDate(this.date, "medium") + separator + this.object;
        } else {
            return this.entityContext.localizationService.l("Meeting of %1", {
                "%1": this.entityContext.internalizationService.formatDate(this.date),
            });
        }
    }
}
